import TitleTextProps from "./ITitleTextProps";
import { Text, makeStyles } from "@fluentui/react-components";
import { dolphinTokens } from "../../utils/Theme";
import { mergeStyles } from "@fluentui/merge-styles";

const useStyles = makeStyles({
	textSection: {
		display: "flex",
		flexDirection: "column",
		justifyContent: "center",
    
		'@media (max-width: 768px)': {
			maxWidth: "100%",
			alignItems: "center",
			textAlign: "center"
		}
	},
	blueText: {
		color: dolphinTokens.colorLightBlue,
	},
	subtitle: {
		color: "#869ab8",
		fontWeight: "600",
		whiteSpace: "pre-line",
	},
	centerAlign: {
		alignItems: "center",
		textAlign: "center"
	},
});

export default function TitleText(props: TitleTextProps) {
	const styles = useStyles();

	const words = props.title.split(" ");
	const n = words.length;
	let before: string[] = [];
	let highlight: string[] = [];

	if (props.titleHighlightedWords > 0) {
		const count = Math.min(props.titleHighlightedWords, n);
		before = words.slice(0, n - count);
		highlight = words.slice(n - count);
	} else if (props.titleHighlightedWords < 0) {
		const count = Math.min(Math.abs(props.titleHighlightedWords), n);
		before = [];
		highlight = words.slice(0, count);
		before = words.slice(count);
	} else {
		before = words;
		highlight = [];
	}

	const alignmentClass = props.alignment === "center" ? styles.centerAlign : "",
		widthClass = mergeStyles({ "@media screen and (min-width: 600px)": { width: props.width || "40%" } }),
		marginClass = mergeStyles({ margin: props.marginBottom || "2rem" }),
		paddingClass = mergeStyles({ padding: props.padding || "0 2rem" }),
		titleMarginClass = mergeStyles({ margin: props.titleMargin || "1rem 0" });

	return (
		<div className={`${styles.textSection} ${alignmentClass} ${widthClass} ${marginClass} ${paddingClass}`}>
			
			<Text block as="h2" size={800} align={props.alignment} className={titleMarginClass}>
				{
					props.titleHighlightedWords < 0
						?	<span>
								<span className={styles.blueText}>{highlight.join(" ")}</span>
								{highlight.length > 0 && before.length > 0 ? " " : ""}
								{before.join(" ")}
							</span>
						: 	<span>
								{before.join(" ")}
								{highlight.length > 0 && before.length > 0 ? " " : ""}
								<span className={styles.blueText}>{highlight.join(" ")}</span>
							</span>
				}
			</Text>

			{
				props.subtitle &&
				<Text block as="h4" size={500} className={styles.subtitle} align={props.alignment}>
					{props.subtitle}
				</Text>
			}
		</div>
	);
}